import { objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { getProp, normalizeValue } from './utils.js';
import isFunction from 'lodash/isFunction.js';
import isPlainObject from 'lodash/isPlainObject.js';

function filterCell(cellValue, _ref) {
  let {
    value,
    type
  } = _ref;
  if (cellValue == null) {
    return false;
  }
  if (!Array.isArray(value)) {
    value = [value];
  }
  if (type === 'exact') {
    return value.some(val => normalizeValue(cellValue) === normalizeValue(val));
  }
  return value.some(val => normalizeValue(cellValue).includes(normalizeValue(val)));
}
function createFilterFunction(props, columns) {
  if (!Array.isArray(props)) {
    props = [props];
  }
  return (row, filter) => {
    return props.some(prop => {
      const column = columns.find(column => column.property === prop);
      let cellValue = getProp(row, prop);
      if (column && column.formatter) {
        cellValue = column.formatter(row, column);
      }
      if (isPlainObject(cellValue)) {
        console.warn(`filtering entire objects is not supported. Please update filter prop ${prop} to reference a specific key in the object.`);
      }
      return filterCell(cellValue, filter);
    });
  };
}
function buildPerColumnFilters(columns) {
  return columns.reduce((acc, column) => {
    if (column.filters && column.filters.length) {
      const filter = {
        prop: column.property,
        value: []
      };
      column.filters.forEach(_ref2 => {
        let {
          checked,
          value
        } = _ref2;
        if (checked) {
          filter.value.push(value);
        }
      });
      if (filter.value.length) {
        if (isFunction(column.filterMethod)) {
          filter.filterFn = column.filterMethod;
        }
        acc.push(filter);
      }
    }
    return acc;
  }, []);
}
function applyFilterToRows(rows, filterFunction, filter, options) {
  const filterRow = (result, row) => {
    if (!row.isGroup && filterFunction(row, filter)) {
      result.push(row);
      return result;
    }
    if (options && Array.isArray(row[options.childKey])) {
      const childRows = row[options.childKey].reduce(filterRow, []);
      if (childRows.length) {
        result.push(_objectSpread2(_objectSpread2({}, row), {}, {
          [options.childKey]: childRows
        }));
      }
    }
    return result;
  };
  return rows.reduce(filterRow, []);
}
function filterRows(_ref3) {
  let {
    rows,
    columns,
    globalFilters,
    options
  } = _ref3;
  const filters = [...globalFilters, ...buildPerColumnFilters(columns)];
  if (filters.length > 0) {
    filters.forEach(filter => {
      const {
        value,
        filterFn
      } = filter;
      const emptyArray = Array.isArray(value) && value.length === 0;
      const noValue = value === undefined || value === '';
      if (emptyArray || noValue && !filterFn) {
        return true;
      }
      const filterFunction = filterFn || createFilterFunction(filter.prop, columns);
      rows = applyFilterToRows(rows, filterFunction, filter, options);
    });
  }
  return rows;
}

export { applyFilterToRows, buildPerColumnFilters, createFilterFunction, filterCell, filterRows };
//# sourceMappingURL=filter.js.map
